import * as React from "react";
import { Provider, connect } from "react-redux";
import { store } from "./redux/store";
import { actionCreators } from "./redux/actions";
import { BookmarkService } from "../../services/bookmarkService";
import { CategoriesService } from "../../services/categoriesService";

import IBookmarkState from "./interfaces/bookmarkState";
import IBookmarkAppProps from "./interfaces/bookmarkAppProps";
import BookmarkCategories from "./bookmarkCategories";
import CreateModal from "./createModal";
import EditModal from "./editModal";
import CategorizeModal from "./categorizeModal";
import ToastBar from "../shared-components/toastbar";
import Tooltip from "./tooltip";
import { render } from "../../common/reactUtils";

class BookmarkApp extends React.Component<IBookmarkAppProps, IBookmarkState> {
  bookmarkService: BookmarkService;
  categoriesService: CategoriesService;
  constructor(props: IBookmarkAppProps) {
    super(props);
    this.bookmarkService = new BookmarkService();
    this.categoriesService = new CategoriesService();
    this.loadData = this.loadData.bind(this);
  }
  /**
   * DO NOT REMOVE. This code seems weird but is intentional. Explanation:
   * `removeRootNode()` replaces the mounting node with all of it's children.
   * The reasoning behind this is that we do not want to change the CSS rules, R
   * which are clean BEM, just to accomodate for eventual root containers.
   *
   * If you remove this, the CSS will break, which jQuery have a hard dependency on,
   * and the sidebar won't display the list of bookmarks.
   * */
  removeRootNode() {
    const node: any = document.getElementById("js-react-bookmarks-app");
    if (node) {
      node.replaceWith(...node.childNodes);
    }
  }

  loadData() {
    this.bookmarkService.getBookmarks(
        (data) => {

        let dataDocuments = data.documents;
        let dataCourses = data.courses;

        let allBookmarks = [...dataDocuments, ...dataCourses];

        if (allBookmarks && allBookmarks.length > 0) {
            this.props.populateBookmarks(allBookmarks);
        } else {
          this.props.setNoContentMessage(
              allBookmarks.length <= 0 ? "Du har inga sparade favoriter" : null
          );
        }
      },
      (error) => {
        this.props.setNoContentMessage(
          "Tillfälligt fel: Kan inte hämta favoriter"
        );
        console.error({ error });
      }
    );

    this.categoriesService.getCategories(
      (data) => {

        if (data) {
          this.props.populateCategories(data);
        }
      },
      (error) => {
        console.error({ error });
      }
    );

    this.removeRootNode(); // DO NOT REMOVE. See comment above `removeRootNode`
  }

  reloadCategories = () => {
    this.categoriesService.getCategories(
      (data) => {
        if (data) {
          this.props.populateCategories(data);
        }
      },
      (error) => {
        console.error({ error });
      }
    );
  };

  componentDidMount(): void {
    this.loadData();
    window.addEventListener("OnPinnedBookmarkChanged", this.reloadCategories);
  }

  componentWillUnmount(): void {
    window.removeEventListener("OnPinnedBookmarkChanged", this.reloadCategories);
  }

  componentDidCatch(error, info): void {
    console.error({ error, info });
  }

  render() {
    return (
      <React.Fragment>
        <CreateModal />
        <EditModal />
        <CategorizeModal />
        <BookmarkCategories />
        <Tooltip />
        <ToastBar />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch): IBookmarkAppProps => {
  return {
    populateBookmarks: (bookmarks) =>
      dispatch(actionCreators.populateBookmarks(bookmarks)),
    populateCategories: (categories) =>
      dispatch(actionCreators.populateCategories(categories)),
    setNoContentMessage: (message) =>
      dispatch(actionCreators.setNoContentMessage(message)),
    toggleCreateModal: () => dispatch(actionCreators.toggleCreateModal()),
    toggleEditModal: () => dispatch(actionCreators.toggleEditModal()),
    toggleTooltip: () => dispatch(actionCreators.toggleTooltip()),
    toggleToastBar: () => dispatch(actionCreators.toggleToastBar()),
  };
};

const ConnectedApp = connect(null, mapDispatchToProps)(BookmarkApp);

export const initialize = () => {
  render(
    <Provider store={store}>
      <ConnectedApp />
    </Provider>,
    "#js-react-bookmarks-app"
  );
};
